import React, { useState } from "react";
import "./App.css";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import OverviewSection from "./components/OverviewSection";
import HighlightsSection from "./components/HighlightsSection";
import GallerySection from "./components/GallerySection";
import PricingSection from "./components/PricingSection";
import AmenitiesSection from "./components/AmenitiesSection";
import LocationSection from "./components/LocationSection";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import StickyFooter from "./components/StickyFooter";
import EnquiryModal from "./components/EnquiryModal";

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleEnquireClick = () => {
    setIsModalOpen(true);
  };

  return (
    <div className="App min-h-screen bg-[#0a1628]">
      <Header onEnquireClick={handleEnquireClick} />
      <HeroSection onEnquireClick={handleEnquireClick} />
      <OverviewSection />
      <HighlightsSection />
      <GallerySection />
      <PricingSection onEnquireClick={handleEnquireClick} />
      <AmenitiesSection />
      <LocationSection />
      <AboutSection />
      <ContactSection />
      <Footer />
      <StickyFooter onEnquireClick={handleEnquireClick} />
      <EnquiryModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
}

export default App;
